if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.count = parseInt(this.dataset.count, 10) || 3;
        this.items = Array.from(this.querySelectorAll('.cart-upsell__item'));

        this.querySelectorAll('[data-upsell-variant]').forEach((select) => {
          select.addEventListener('change', () => {
            const price = select.closest('form').querySelector('[data-upsell-price]');
            price.textContent = select.selectedOptions[0].dataset.price;
          });
        });
        this.querySelectorAll('[data-upsell-form]').forEach((form) => {
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            this.add(form);
          });
        });

        // The popup's markup is rendered once at page load, so the cart is
        // re-checked every time it opens (it opens on each add to cart).
        const notification = document.getElementById('cart-notification');
        if (notification) {
          new MutationObserver(() => {
            if (notification.classList.contains('active')) this.refresh();
          }).observe(notification, { attributes: true, attributeFilter: ['class'] });
        }
      }

      // Shows the first `count` upsells that aren't already in the cart.
      // Something added from here stays visible as "Agregado" while the popup
      // is open, and drops out the next time it opens.
      refresh() {
        fetch(`${routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const inCart = new Set(cart.items.map((item) => String(item.product_id)));
            let visible = 0;
            this.items.forEach((item) => {
              const show = !inCart.has(item.dataset.productId) && visible < this.count;
              item.hidden = !show;
              if (show) {
                visible += 1;
                this.reset(item);
              }
            });
            this.hidden = visible === 0;
          })
          .catch(() => {
            this.hidden = true;
          });
      }

      reset(item) {
        const button = item.querySelector('[data-upsell-add]');
        const select = item.querySelector('select');
        button.disabled = false;
        button.textContent = this.dataset.addLabel;
        if (select) select.disabled = false;
      }

      add(form) {
        const button = form.querySelector('[data-upsell-add]');
        const select = form.querySelector('select');
        const body = new FormData(form);
        body.append('sections', 'cart-icon-bubble,cart-notification-button');
        button.disabled = true;

        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
          body,
        })
          .then((response) => response.json())
          .then((state) => {
            if (state.status) throw new Error(state.description);
            this.renderSections(state.sections);
            button.textContent = this.dataset.addedLabel;
            if (select) select.disabled = true;
          })
          .catch(() => {
            button.disabled = false;
            button.textContent = this.dataset.errorLabel;
          });
      }

      // Updates the header cart count and the popup's "Ver carrito (n)" button.
      renderSections(sections) {
        if (!sections) return;
        ['cart-icon-bubble', 'cart-notification-button'].forEach((id) => {
          const target = document.getElementById(id);
          if (!target || !sections[id]) return;
          const html = new DOMParser().parseFromString(sections[id], 'text/html');
          target.innerHTML = html.querySelector('.shopify-section').innerHTML;
        });
      }
    }
  );
}
